<template>
  <ul :class="`${listClasses} toggling-dropdown`">
    <li class="dropdown-header">Identity</li>
    <AppColumnToggle
      column="show_employee_id"
      :active="aboutFields.show_employee_id"
      @change="handleChange"
    >
      Employee ID
    </AppColumnToggle>
    <AppColumnToggle
      column="show_birthday"
      :active="aboutFields.show_birthday"
      @change="handleChange"
    >
      Birthday
    </AppColumnToggle>
    <AppColumnToggle
      column="show_ip_address"
      :active="aboutFields.show_ip_address"
      @change="handleChange"
    >
      IP address (date)
    </AppColumnToggle>

    <li class="dropdown-header">Work contact</li>
    <AppColumnToggle
      column="show_work_state_country"
      :active="aboutFields.show_work_state_country"
      @change="handleChange"
    >
      State, Country
    </AppColumnToggle>
    <AppColumnToggle
      column="show_work_email"
      :active="aboutFields.show_work_email"
      @change="handleChange"
    >
      Work email
    </AppColumnToggle>
    <AppColumnToggle
      column="show_work_phone"
      :active="aboutFields.show_work_phone"
      @change="handleChange"
    >
      Work phone
    </AppColumnToggle>

    <li class="dropdown-header">Personal contact</li>
    <AppColumnToggle
      column="show_home_state_country"
      :active="aboutFields.show_home_state_country"
      @change="handleChange"
    >
      State, Country
    </AppColumnToggle>
    <AppColumnToggle
      column="show_personal_email"
      :active="aboutFields.show_personal_email"
      @change="handleChange"
    >
      Personal email
    </AppColumnToggle>
    <AppColumnToggle
      column="show_personal_phone"
      :active="aboutFields.show_personal_phone"
      @change="handleChange"
    >
      Personal phone
    </AppColumnToggle>

    <li
      v-if="customFieldsList.length"
      class="dropdown-header"
    >
      Custom
    </li>
    <AppColumnToggle
      v-for="field in customFieldsList"
      :key="field.key"
      :column="`show_custom_${field.key}`"
      :active="customFieldVisible(field)"
      @change="handleChange"
    >
      {{ field.title }}
    </AppColumnToggle>
  </ul>
</template>
<script>
import { mapState } from 'vuex';
import AppColumnToggle from '../AppColumnToggle.vue';

export default {
  name: 'MembersInfoFields',
  components: {
    AppColumnToggle,
  },
  props: {
    aboutFields: {
      type: Object,
      default: () => ({}),
    },
    listClasses: {
      type: String,
      default: 'pl-0 list-style-none',
    },
    customVisibleByDefault: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['change'],
  computed: {
    ...mapState(['organization']),
    customFieldsList() {
      return this.organization.member_profile_fields;
    },
  },
  methods: {
    handleChange(payload) {
      this.$emit('change', payload);
    },
    customFieldVisible(field) {
      return this.aboutFields[`show_custom_${field.key}`] ?? this.customVisibleByDefault;
    },
  },
};
</script>
